// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1_Uea","label":"SetPasswdForm_label__3LRe9"};